import React, { useState, useCallback } from 'react';
import { FacilityList } from './FacilityList';
import { Scheduler, SchedulerAllFacilities } from './Scheduler';

export type ViewMode = 'single' | 'all';

export const SchedulerView: React.FC = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('single');
  const [hiddenFacilityIds, setHiddenFacilityIds] = useState<Set<string>>(new Set());

  const toggleFacilityVisibility = useCallback((id: string) => {
    setHiddenFacilityIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  return (
    <div className="flex h-full flex-col">
      <div className="flex-1 flex overflow-hidden">
        <FacilityList
          viewMode={viewMode}
          setViewMode={setViewMode}
          hiddenFacilityIds={hiddenFacilityIds}
          onToggleFacilityVisibility={toggleFacilityVisibility}
        />
        {viewMode === 'single' ? (
          <Scheduler />
        ) : (
          <SchedulerAllFacilities hiddenFacilityIds={hiddenFacilityIds} />
        )}
      </div>
    </div>
  );
};
